import {
  API_HOST,
  API_IMG_HOST,
  YZ_HOST_API,
  YT_HOST_API,
  API_HOST_JAVA
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import Vueaxios from 'vue-axiosp'
const axiosPhp = axios.create({
  baseURL: API_HOST
})
// axiosPhp.defaults.baseURL = API_HOST
axiosPhp.defaults.headers['Content-Type'] = 'application/json'
axiosPhp.defaults.timeout = 1000 * 15
axiosPhp.defaults.headers.authKey = Lockr.get('authKey')
axiosPhp.defaults.headers.sessionId = Lockr.get('sessionId')
axiosPhp.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params)
}

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}

// 返回处理
axiosPhp.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code == 101) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    console.log('删除了对象customer.js')
    Lockr.rm('firstRoutePath')
    return response
  } else if (response.data.code > 101 && response.data.code != 200) {
    // _g.toastMsg('error', response.data.error)
    if (response.data.code == 401) {
      // 跳转到登录页
      router.push({ path: '/login' })
    }
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 添加请求拦截器
axiosPhp.interceptors.request.use(config => {
  removePending(config) // 在一个ajax发送前执行一下取消操作
  config.cancelToken = new CancelToken((c) => {
    // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    pending.push({
      u: config.url + '&' + config.method,
      f: c
    })
  })
  return config
}, error => {
  return Promise.reject(error)
})
// 管理员登录
export function login (username, password, remember) {
  return axiosPhp.post('customer/base/login', {
    username: username,
    password: password,
    remember: remember
  })
}
// 成员登录
export function memberLogin (username, password, remember) {
  return axiosPhp.post('customer/base/companyUserLogin', {
    username: username,
    password: password,
    remember: remember
  })
}
// 退出
export function logout () {
  let url = 'customer/base/quit'
  return axiosPhp.get(url)
}
// 获取客户来源列表
export function getCustomerSourceList (page, search) {
  let url = 'customer/source'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 添加客户来源
export function addCustomerSource (name) {
  let url = 'customer/source'
  return axiosPhp.post(url, {
    name: name
  })
}
// 编辑客户来源
export function editCustomerSource (name, id) {
  let url = 'customer/source/' + id
  return axiosPhp.put(url, {
    name: name
  })
}
// 删除客户来源
export function deleteCustomerSource (id) {
  let url = 'customer/source/' + id
  return axiosPhp.delete(url)
}
// 获取客户事件列表
export function getCustomerEventList (page, limit) {
  let url = 'customer/event'
  return axiosPhp.get(url, {
    params: {
      limit: limit,
      page: page
    }
  })
}
// 获取客户等级数据
export function getCustomerStage () {
  let url = 'customer/stage'
  return axiosPhp.get(url)
}
// 获取客户属性列表
export function getCustomerAttributeList () {
  let url = 'customer/gold'
  return axiosPhp.get(url)
}
// 编辑客户属性
export function editCustomerAttribute (identity, name, score, option, is_system) {
  let url = 'customer/gold/updateDetail'
  return axiosPhp.post(url, {
    identity: identity,
    name: name,
    score: score,
    option: option,
    is_system: is_system
  })
}
// 设置客户属性是否常用
export function setCustomerAttributeIsNormal (identity, is_normal) {
  let url = 'customer/gold/normal'
  return axiosPhp.post(url, {
    identity: identity,
    is_normal: is_normal
  })
}
// 添加客户属性
export function addCustomerAttr (identity, name, score, type, option, is_normal) {
  let url = 'customer/gold'
  return axiosPhp.post(url, {
    identity: identity,
    name: name,
    score: score,
    type: type,
    option: option,
    is_normal: is_normal
  })
}
// 删除客户属性
export function deleteCustomerAttr (identity) {
  let url = 'customer/gold/deleteGold'
  return axiosPhp.delete(url, {
    data: {
      identity: identity
    }
  })
}
// 编辑客户事件
export function editCustomerEvent (data, id) {
  let url = 'customer/event/' + id
  return axiosPhp.put(url, data)
}
// 编辑自定义的客户事件
export function editNoSystemCustomerEvent (name, identity, score, stage_id, attr, id) {
  let url = 'customer/event/' + id
  return axiosPhp.put(url, {
    name: name,
    identity: identity,
    score: score,
    stage_id: stage_id,
    attr: attr
  })
}
// 添加客户自定义事件
export function createCustomerEvent (name, identity, score, stage_id, attr) {
  let url = 'customer/event/'
  return axiosPhp.post(url, {
    name: name,
    identity: identity,
    score: score,
    stage_id: stage_id,
    attr: attr
  })
}
// 删除客户自定义事件
export function deleteCustomerEvent (id) {
  let url = 'customer/event/' + id
  return axiosPhp.delete(url, {
    data: {
      id: id
    }
  })
}
// 编辑客户等级
export function editCustomerStage (name, id) {
  let url = 'customer/stage/' + id
  return axiosPhp.put(url, {
    name: name
  })
}
// 获取客户等级
export function getCustomerStageList () {
  let url = 'customer/stage'
  return axiosPhp.get(url)
}
// 获取客户列表
export function getCustomerList (page, lastId, search) {
  let url = 'customer/customer/search'
  return axiosPhp.post(url, {
    limit: 10,
    page: page,
    search: search,
    lastId: lastId
  })
}
// 添加客户
export function addCustomer (realname, mobile, mobile_verified, sex, email, email_verified) {
  let url = 'customer/customer'
  return axiosPhp.post(url, {
    realname: realname,
    mobile: mobile,
    mobile_verified: mobile_verified,
    sex: sex,
    email: email,
    email_verified: email_verified
  })
}
// 更新客户信息
export function editCustomer (data) {
  let url = 'customer/customer/' + data.id
  return axiosPhp.put(url, data)
}
// 删除客户
export function deleteCustomer (id) {
  let url = 'customer/customer/' + id
  return axiosPhp.delete(url)
}
// 获取客户标签
export function getCustomerTag (search) {
  let url = 'customer/tag'
  return axiosPhp.get(url, {
    params: {
      search: search
    }
  })
}
// 添加客户标签
export function addCustomerTag (name) {
  let url = 'customer/tag'
  return axiosPhp.post(url, {
    name: name
  })
}
// 编辑 客户标签
export function editCustomerTag (data, id) {
  let url = 'customer/tag/' + id
  return axiosPhp.put(url, data)
}
// 删除 客户标签
export function delectCustomerTag (id, is_all) {
  let url = 'customer/tag/' + id
  return axiosPhp.delete(url, {
    params: {
      is_all: is_all
    }
  })
}
// 客户标签 标签统计
export function tagStatistic (id, data) {
  let url = 'customer/tagStatistic/detail/' + id
  return axiosPhp.get(url, {
    params: data
  })
}
// 获取客户详情时间轴
export function getCustomerDetailTimeline (id) {
  let url = 'customer/customer/timeLine/' + id
  return axiosPhp.get(url)
}
// 获取客户详情属性
export function getCustomerDetailItems (id) {
  let url = 'customer/customer/' + id
  return axiosPhp.get(url)
}
// 获取群组分组列表
export function getGroupTypeList () {
  let url = 'customer/queryGroup'
  return axiosPhp.get(url)
}
// 添加群组分组
export function addGroupType (name) {
  let url = 'customer/queryGroup'
  return axiosPhp.post(url, {
    name: name
  })
}
// 删除群组分组
export function deleteGroupType (id) {
  let url = 'customer/queryGroup/' + id
  return axiosPhp.delete(url)
}
// 编辑群组分组
export function editGroupType (name, id) {
  let url = 'customer/queryGroup/' + id
  return axiosPhp.put(url, {
    name: name
  })
}
// 获取群组列表
export function getGroupList (page, search, limit) {
  let url = 'customer/query'
  return axiosPhp.get(url, {
    params: {
      limit: limit,
      page: page,
      search: search
    }
  })
}
// 删除群组
export function deleteGroup (id) {
  let url = 'customer/query/' + id
  return axiosPhp.delete(url)
}
// 获取群组详情
export function getGroupDetail (id, page, search, lastId) {
  let url = 'customer/query/' + id
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search,
      lastId: lastId
    }
  })
}
// 添加群组
export function addGroup (name, type, query) {
  let url = 'customer/query'
  return axiosPhp.post(url, {
    name: name,
    type: type,
    query: query
  })
}
// 动态群组详情编辑群组
export function editGroupManageDetail (query, id) {
  let url = 'customer/query/' + id
  return axiosPhp.put(url, {
    query: query
  })
}
// 静态群组详情添加客户
export function addGroupManageDetail (query, id) {
  let url = 'customer/query/addCustomer'
  return axiosPhp.post(url, {
    query: query,
    id: id
  })
}
// 移动群组到分组
export function confirmChooseGroupType (group_id, query_arr) {
  let url = 'customer/query/changeGroup'
  return axiosPhp.post(url, {
    group_id: group_id,
    query_arr: query_arr
  })
}
// 数据导入历史
export function getImportDataHistoryList (page) {
  let url = 'customer/customer/importHistory'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page
    }
  })
}
// 数据导出历史
export function getExportDataHistoryList (page) {
  let url = 'customer/customer/exportHistory'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page
    }
  })
}
// 订单导出记录
export function getExportOrderList (page) {
  let url = 'v2/zy/order/selectExportRc'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page
    }
  })
}
// 管易订单--获取冠以订单参数
export function getGuanyi () {
  let url = 'order/Guanyiapi/getGuanyi'
  return axiosPhp.get(url)
}
// 管易订单--新增/修改管易
export function editGuanyi (data) {
  let url = 'order/Guanyiapi/editGuanyi'
  return axiosPhp.post(url, data)
}
// 智能群组刷新
export function refreshCustomer (id) {
  let url = 'customer/query/refreshQuery'
  return axiosPhp.post(url, {
    id: id
  })
}
// 新增客户等级统计
export function getCustomerStageData () {
  let url = 'customer/statistic/stage'
  return axiosPhp.get(url, {
    params: null
  })
}
// 30天粉丝留存变化
export function getCustomerStatisticStay () {
  let url = 'customer/statistic/fans'
  return axiosPhp.get(url, {
    params: null
  })
}
// 新增客户统计
export function getAddNewCustomerStatistic (day) {
  let url = 'customer/statistic/new'
  return axiosPhp.get(url, {
    params: {
      day
    }
  })
}
// 首页--灵感文章TOP10
export function getInspirationArticle () {
  let url = 'afflatus/top/index'
  return axiosPhp.get(url, {
    params: {
      limit: 10
    }
  })
}
// 人均活跃度统计
export function getCustomerActive (day) {
  let url = 'customer/statistic/activity'
  return axiosPhp.get(url, {
    params: {
      day: day
    }
  })
}
// 客户性别分布
export function getAreaAndSexStatistic () {
  let url = 'customer/statistic/areaAndSex'
  return axiosPhp.get(url, {
    params: null
  })
}
// 各个年龄段人数占比统计
export function getAgeRatioStatistic () {
  let url = 'customer/statistic/ageRatio'
  return axiosPhp.get(url, {
    params: null
  })
}
// 当前关注人数
export function getWeChatCurrentCount (id) {
  let url = 'customer/statistic/currentAttention'
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// 今日关注人数
export function getTodayAttentionCount (id) {
  let url = 'customer/statistic/attention'
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// 今日取消关注公众号人数
export function getTodayCancelAttention (id) {
  let url = 'customer/statistic/cancelAttention'
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// 销售统计 订单概览
export function getSalesStatistic (params) {
  let url = 'customer/statistic/sales'
  return axiosPhp.get(url, {
    params: params
  })
}
// 热销商品top 10
export function getHotSalesProduct (type) {
  let url = 'customer/statistic/hotSale'
  return axiosPhp.get(url, {
    params: {
      type: type
    }
  })
}
// 保存查询条件
export function saveQuerycondition (name, query) {
  let url = 'customer/search-condition'
  return axiosPhp.post(url, {
    name: name,
    type: 0,
    query: query
  })
}
// 获取筛选条件
export function getQueryCondition () {
  let url = 'customer/search-condition'
  return axiosPhp.get(url, {
    params: null
  })
}
// 获取所在群组列表
export function getGroupById (id) {
  let url = 'customer/customer/getGroup/' + id
  return axiosPhp.get(url, {
    params: null
  })
}
// 短信签名列表
export function getSmsSignList (limit, page) {
  let url = 'customer/SmsSign'
  return axiosPhp.get(url, {
    params: {
      limit: limit,
      page: page
    }
  })
}
// 活动列表数据
export function getActivityList (page, search) {
  let url = 'wechat/marketing'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 活动列表 作弊功能
export function cheatActivity (id) {
  let url = 'wechat/marketing/cheat/' + id
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// 活动列表 删除功能
export function deleteActivity (id) {
  let url = 'wechat/marketing/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 活动详情
export function getActivityDetails (id) {
  let url = 'wechat/marketing/' + id
  return axiosPhp.get(url)
}
// 活动导出
export function exportActivity (id, search) {
  let url = 'wechat/marketing/export/' + id
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}
// SN码列表 兑奖
export function sendPrize (id) {
  let url = 'wechat/marketing/sendprize/' + id
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// SN码列表 取消兑奖
export function cancelPrize (id) {
  let url = 'wechat/marketing/cancelprize/' + id
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// 活动列表 开始活动功能
export function beginActivity (id) {
  let url = 'wechat/marketing/start/' + id
  return axiosPhp.get(url)
}
// 活动列表 结束活动功能
export function stopActivity (id) {
  let url = 'wechat/marketing/enable'
  return axiosPhp.post(url, {
    ids: id
  })
}
// 活动列表 作弊页面删除功能
export function deleteCheatActivity (id) {
  let url = 'wechat/marketing/deleteCheat' + id
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// 活动列表 新增活动提交
export function addAcivity (data) {
  let url = 'wechat/marketing'
  return axiosPhp.post(url, data)
}
// 活动列表 编辑功能提交
export function modifyActivity (id, data) {
  let url = 'wechat/marketing/' + id
  return axiosPhp.put(url, data)
}
// 活动列表 编辑 获取活动详情
export function editFormData (id) {
  let url = 'wechat/marketing/' + id
  return axiosPhp.get(url)
}
// 大转盘列表 编辑
export function editActivity (id) {
  let url = 'wechat/marketing/edit/' + id
  return axiosPhp.post(url)
}
// 大转盘复制功能
export function copyAcivity (id) {
  let url = 'wechat/marketing/copy/' + id
  return axiosPhp.get(url)
}
// 大转盘统计功能
export function statisticAcivity (id, page, search) {
  let url = 'wechat/marketing/statistic/' + id
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10,
      search: search
    }
  })
}
// 获取SN码列表
export function getSNlist (id, page, limit) {
  let url = 'wechat/marketing/snManage'
  return axiosPhp.get(url, {
    params: {
      type: 1,
      id: id,
      page: page,
      limit: limit
    }
  })
}
// SN码列表 删除功能
export function deleteSnManage (id) {
  let url = 'wechat/marketing/snDelete/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 短信签名添加
export function addSmsSign (name) {
  let url = 'customer/SmsSign'
  return axiosPhp.post(url, {
    sign_name: name
  })
}
// 新增客户统计 人均活跃度统计
export function getNewCustomerStatistic () {
  let url = 'customer/statistic/new'
  return axiosPhp.get(url, {
    params: null
  })
}
// 短信分组列表
export function getMessageGroupList (search) {
  let url = 'customer/smsGroup'
  return axiosPhp.get(url, {
    search: search
  })
}
// 短信分组添加
export function addMessageGroup (name) {
  let url = 'customer/smsGroup'
  return axiosPhp.post(url, {
    name: name
  })
}
// 短信分组编辑
export function editMessageGroup (name, id) {
  let url = 'customer/smsGroup/' + id
  return axiosPhp.put(url, {
    name: name
  })
}
// 删除短信分组
export function deleteMessageGroup (id) {
  let url = 'customer/smsGroup/' + id
  return axiosPhp.delete(url)
}
// 短信模板列表
export function getMessageList (page, search, show_code) {
  let url = 'customer/sms'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10,
      search: search,
      show_code: show_code
    }
  })
}
// 获取短信签名（短信列表页用）
export function loadSigns () {
  let url = 'customer/SmsSign'
  return axiosPhp.get(url)
}
// 短信模板添加
export function addMessage (sms_name, verify_link, type, tem_content, status, sign_id, content) {
  let url = 'customer/sms'
  return axiosPhp.post(url, {
    sms_name: sms_name,
    verify_link: verify_link,
    type: type,
    content: content,
    status: status,
    sign_id: sign_id,
    tem_content: tem_content
  })
}
// 短信编辑
export function editMessage (sms_name, verify_link, type, content, status, sign_id, id, tem_content) {
  let url = 'customer/sms/' + id
  return axiosPhp.put(url, {
    sms_name: sms_name,
    verify_link: verify_link,
    type: type,
    content: content,
    status: status,
    sign_id: sign_id,
    tem_content: tem_content
  })
}
// 删除短信
export function deleteMessage (id, template_id) {
  let url = 'customer/sms/' + id
  return axiosPhp.delete(url, {
    params: {
      template_id: template_id
    }
  })
}
// 短信发送记录
export function getSendMegListRecord (page) {
  let url = 'customer/smsSend'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10
    }
  })
}
// 群发短信
export function sendGroupMessage (group_ids, template_id, params) {
  let url = 'customer/sms'
  return axiosPhp.post(url, {
    group_ids: group_ids,
    template_id: template_id,
    params: params
  })
}
// 移动短信模板至分组
export function chooseMessageGroup (group_id, sms_arr) {
  let url = 'customer/sms/move'
  return axiosPhp.post(url, {
    group_id: group_id,
    sms_arr: sms_arr
  })
}
//
export function megSendRecodStatistic (id) {
  let url = 'customer/smsSend/sendStatistic/' + id
  return axiosPhp.get(url, {
    params: null
  })
}
// 短信列表短信发送统计
export function megSendStatistic (id, limit, page) {
  let url = 'customer/sms/sendStatistic/' + id
  return axiosPhp.get(url, {
    params: {
      limit: limit,
      page: page
    }
  })
}
// 发送短信
export function sendMessage (model_id, sms_id, query_id, template_id, content, send_type, mobile) {
  let url = 'customer/sms/send'
  return axiosPhp.post(url, {
    model_id: model_id,
    sms_id: sms_id,
    query_id: query_id,
    template_id: template_id,
    content: content,
    send_type: send_type,
    mobile: mobile
  })
}
// 同步短信状态
export function updateMsgStatusNow () {
  let url = 'customer/sms/updateStatus'
  return axiosPhp.get(url)
}
// 获取二维码分组
export function getQrCodeCateList (page, search) {
  let url = 'customer/qrcodeCate'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10,
      search: search
    }
  })
}
/*
// 移动微页面到分组
export function moveMicroPage (group_id, query_arr) {
  let url = 'micropage/indexapi/moveGroup'
  return axiosPhp.post(url, {
    group_id: group_id,
    ids: query_arr
  })
}
// 获取微页面查询分组的数据
export function getMircoPageData () {
  let url = 'micropage/indexapi/getcate'
  return axiosPhp.get(url)
}
// 微页面  推广
export function getQrcode (code) {
  let url = 'micropage/indexapi/getQrcode'
  return axiosPhp.post(url, {
    code: code
  })
}
// 获取微页面分组
export function getMicroPageList (data) {
  let url = 'micropage/indexapi/getcate'
  return axiosPhp.get(url, data)
}
// 添加微页面分组
export function addMicroPageGroup (name) {
  let url = 'micropage/indexapi/saveGroup'
  return axiosPhp.post(url, {
    name: name
  })
}
// 微页面  获取 可追踪url列表
export function getUrl (sceneid, page, limit) {
  let url = 'micropage/indexapi/urlList'
  return axiosPhp.post(url, {
    sceneid: sceneid,
    page: page,
    limit: limit
  })
}
// 微页面  删除 可追踪url列表数据
export function deleteUrlData (id) {
  let url = 'micropage/indexapi/delSceneurl'
  return axiosPhp.post(url, {
    id: id
  })
}
// 微页面  添加 可追踪url
export function addCustomerSourceUrl (data) {
  let url = 'micropage/indexapi/saveSceneurl'
  return axiosPhp.post(url, data)
}
// 微页面  页面设置 保存
export function updateScene (updateData) {
  let url = 'micropage/indexapi/updateScene/'
  return axiosPhp.post(url, updateData)
}
// 设置  微页面
export function settingScene (id) {
  let url = 'micropage/indexapi/sceneset/' + id
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}

// 获取表单数据  微页面
export function getSceneData (id, page, limit) {
  let url = 'micropage/indexapi/getSceneData'
  return axiosPhp.post(url, {
    id: id,
    page: page,
    limit: limit
  })
}
// 编辑  微页面
export function sceneCreate (id) {
  let url = 'micropage/indexapi/sceneCreate/' + id
  return axiosPhp.get(url)
}
// 添加  微页面
export function sceneAdd (id) {
  let url = 'micropage/indexapi/scene'
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}

// 编辑微页面分组
export function editMircoPageGroup (name, id) {
  let url = 'micropage/indexapi/saveGroup/' + id
  return axiosPhp.put(url, {
    id: id,
    name: name
  })
}
// 删除微页面分组
export function deleteMircoPageGroup (id) {
  let url = 'micropage/indexapi/delGroup/' + id
  return axiosPhp.post(url, {
    id: id
  })
}
// 删除一条微页面列表数据
export function deleteMicroPage (id) {
  let url = 'micropage/indexapi/status'
  return axiosPhp.post(url, {
    id: id,
    status: 1,
    field: 'delete_int'
  })
}
// 获取微页面分组列表
export function getMicroPageGroup (data) {
  let url = 'micropage/indexapi/getcate'
  return axiosPhp.get(url, data)
}
// 获取微页面列表
export function getMircoPageList (page, limit, data, search) {
  let url = 'micropage/indexapi/getscenelist'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: limit,
      data: data,
      search: search
    }
  })
}
*/
// 活动管理  列表 获取统计数据
export function getWinPrizeData (id) {
  let url = 'wechat/marketing/statistics/' + id
  return axiosPhp.get(url)
}

// 获取微页面--设置--页面设置--公众号
export function getPublicData () {
  let url = 'admin/wechat/indexApi'
  return axiosPhp.get(url)
}
// 添加二维码分组
export function addQrCodeType (catename) {
  let url = 'customer/qrcodeCate'
  return axiosPhp.post(url, {
    catename: catename
  })
}
// 编辑二维码分组
export function editQrCodeType (catename, id) {
  let url = 'customer/qrcodeCate/' + id
  return axiosPhp.put(url, {
    catename: catename
  })
}
// 删除二维码分组
export function deleteQrCodeType (id) {
  let url = 'customer/qrcodeCate/' + id
  return axiosPhp.delete(url)
}

// 获取二维码列表
export function getQrCodeList (data) {
  let url = 'customer/qrcode'
  return axiosPhp.get(url, data)
}
// 添加页面 获取来源
export function getQrCodeSources (source) {
  let url = 'customer/qrcode'
  return axiosPhp.post(url, {
    source: source
  })
}
// 添加页面 提交数据
export function addQrcode (data) {
  let url = 'customer/qrcode'
  return axiosPhp.post(url, data)
}
// 编辑页面 提交数据
export function editQrcode (data, id) {
  let url = 'customer/qrcode/' + id
  return axiosPhp.put(url, data)
}
// 删除一条 二维码
export function deleteQrcode (id) {
  let url = 'customer/qrcode/' + id
  return axiosPhp.delete(url)
}
// 多个二维码 分组编辑
export function ChooseGroup (group_id, query_arr) {
  let url = 'customer/qrcode/batchCate'
  return axiosPhp.post(url, {
    cate: group_id,
    ids: query_arr
  })
}

// 编辑页面 获取单条二维码数据
export function getQrcodeListData (id) {
  let url = 'customer/qrcode/' + id
  return axiosPhp.get(url)
}
// 获取查询来源的数据
export function getSourceData () {
  let url = 'customer/source'
  return axiosPhp.get(url)
}
// 获取查询分组的数据
export function getCateData () {
  let url = 'customer/qrcodeCate'
  return axiosPhp.get(url)
}

// 二维码标签列表
export function getLabelList (data) {
  let url = 'customer/qrcodeCate'
  return axiosPhp.get(url, data)
}
// 自动流程分组列表
export function getAutomationGroupList (name) {
  let url = 'customer/automationGroup'
  return axiosPhp.get(url, {
    params: {
      search: {
        name: name
      }
    }
  })
}
// 流程列表
export function getAutomationList (page, groupId, name) {
  let url = 'customer/automation'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10,
      group_id: groupId,
      search: {
        name: name
      }
    }
  })
}
// 自动流程分组添加
export function addAutomationGroup (name) {
  let url = 'customer/automationGroup'
  return axiosPhp.post(url, {
    name: name
  })
}
// 删除自动流程
export function deleteAutomation (id) {
  let url = 'customer/automation/' + id
  return axiosPhp.delete(url)
}
// 自动流程分组删除功能
export function deleteAutomationGroupById (id) {
  let url = 'customer/automationGroup/' + id
  return axiosPhp.delete(url)
}
// 自动流程分组编辑功能
export function editAutomationGroupById (name, id) {
  let url = 'customer/automationGroup/' + id
  return axiosPhp.put(url, {
    name: name
  })
}
// 自动流程分组更改
export function moveAutomationGroupId (groupId, ids) {
  let url = 'customer/automation/move'
  return axiosPhp.post(url, {
    ids: ids,
    group_id: groupId
  })
}
// 创建自动流程
export function createAutomation (name, queryId, type, status, condition) {
  let url = 'customer/automation'
  return axiosPhp.post(url, {
    name: name,
    query_id: queryId,
    type: type,
    status: status,
    condition: condition
  })
}
// 获取短信列表给自动化流程用
export function getMessageListForNode (page, search) {
  let url = 'customer/sms'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10000000000,
      search: search
    }
  })
}
// 获取公众号列表给自动化流程用
export function getWechatPublicListForNode (page) {
  let url = 'customer/wechatPublic'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: '',
      no_show_disable: 1
    }
  })
}
// 获取公众号列表全部
export function getWechatPublicListAll (page, modelId) {
  let url = 'customer/wechatPublic'
  return axiosPhp.get(url, {
    params: {
      page: page,
      model_id: modelId,
      limit: '',
      no_show_disable: ''
    }
  })
}
// 获取微页面列表给自动化流程用
export function getWePagesListForNode (page, search) {
  let url = 'customer/scene'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: '',
      search: {
        publish_status: 1
      }
    }
  })
}
// 营销活动 事件列表
export function getEventList (page) {
  let url = 'customer/event/listForMarketing'
  return axiosPhp.get(url)
}
// 自动化流程模板消息
export function getTemplateList (page) {
  let url = 'customer/wechatTemplate'
  return axiosPhp.get(url)
}
// 删除签名
export function deleteSign (id) {
  let url = 'customer/SmsSign/' + id
  return axiosPhp.delete(url)
}
// 更新短信签名
export function updateSign (page) {
  let url = 'customer/smsSign/updateStatus'
  return axiosPhp.get(url)
}
// 自动流程微信回复
export function autoFlowWechatReply (name, original_id, msgtype, content, img_url, title, image, description, link_url) {
  let url = 'customer/WechatCustomerMsg'
  return axiosPhp.post(url, {
    name: name,
    original_id: original_id,
    msgtype: msgtype,
    content: content,
    local_url: img_url,
    title: title,
    image: image,
    description: description,
    url: link_url
  })
}
// 自动流程保存
export function saveFlowChart (name, query_id, type, status, condition) {
  let url = 'customer/automation'
  return axiosPhp.post(url, {
    name: name,
    query_id: query_id,
    type: type,
    status: status,
    condition: condition
  })
}
// 获取短信条数
export function getSmsNum () {
  let url = 'customer/smsBalance'
  return axiosPhp.get(url)
}
// 获取自动化分组列表
export function getFlowChartGroup () {
  let url = 'customer/automationGroup'
  return axiosPhp.get(url)
}
// 获取自动化流程具体数据
export function getFlowChart (page, limit, group_id, search) {
  let url = 'customer/automation'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: limit,
      group_id: group_id,
      search: search
    }
  })
}
// 获取自动化流程详情
export function getFlowChartDetail (id) {
  let url = 'customer/automation/' + id
  return axiosPhp.get(url)
}
// 获取会员列表
export function getMemberList (page, lastId, search) {
  let url = 'customer/customer/search'
  return axiosPhp.get(url, {
    limit: 10,
    page: page,
    search: search,
    lastId: lastId,
    is_vip: 1
  })
}
// 获取会员权益订单
export function getMemberInterestOrderList (page, search) {
  let url = 'admin/grade_order/index'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 获取会员身份信息
export function getCustomerIdMessage (id) {
  let url = 'customer/customer/identity/' + id
  return axiosPhp.get(url)
}
// 获取会员详情收货地址
export function getMemberDetailsReceiveAdress (fansId) {
  let url = 'customer/customer/address/' + fansId
  return axiosPhp.get(url)
}
// 改变会员订单状态
export function changeMemberInstrestOrderStatus (id, status) {
  let url = 'admin/grade_order/status'
  return axiosPhp.post(url, {
    id: id,
    status: status
  })
}
// 积分商品订单导出
export function exportProductOrder (search) {
  let url = 'admin/order/export'
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}
// 客户管理客户导出
export function exportCustomer (search, gold, is_vip) {
  let url = 'customer/setup/newExport'
  return axiosPhp({
    method: 'post',
    url: url,
    data: {
      search: search,
      gold: gold,
      is_vip: is_vip
    },
    responseType: 'blob'
  })
}
// 数据导出历史下载
export function exportDataHistory (id) {
  let url = 'customer/customer/downLoadFile/' + id
  return axiosPhp({
    method: 'get',
    url: url,
    params: null,
    responseType: 'blob'
  })
}
// 会员权益订单导出
export function exportMemberInterestOrder (search) {
  let url = 'admin/grade_order/export'
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}
// 签到有礼订单导出
export function exporeSignInOrder (search) {
  let url = 'admin/Signin/exportOrder'
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}
// 注册有礼订单导出
export function exportRegisterOrder (search) {
  let url = 'admin/Zhuce/exportOrder'
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}
// 群组成员导出
export function exportGroupDetail (id) {
  return axiosPhp({
    method: 'get',
    url: 'customer/setup/queryExport/' + id,
    responseType: 'blob'
  })
}
// 会员导出
export function exportMemberList (search) {
  return axiosPhp({
    method: 'get',
    url: 'customer/setup/export',
    params: {
      search: search,
      is_vip: 1
    },
    responseType: 'blob'
  })
}
// 短信发送统计导出
export function exportSmsStat (id) {
  return axiosPhp({
    method: 'get',
    url: 'customer/smsSend/export/' + id,
    params: null,
    responseType: 'blob'
  })
}
// 在导出记录页，下载已生成的文件
export function exportDownLog (id) {
  return axiosPhp({
    method: 'get',
    url: 'customer/setup/downLoad',
    params: {
      id: id
    },
    responseType: 'blob'
  })
}
// 线下活动导出
export function exportFieldTotal (id) {
  return axiosPhp({
    method: 'get',
    url: 'wechat/ActivityStatics/subscribeExport/' + id,
    params: {
      id: id
    },
    responseType: 'blob'
  })
}
// 线下活动参与
export function exportFieldManage (search) {
  return axiosPhp({
    method: 'get',
    url: 'wechat/activityStatics/exportData',
    params: {
      search: search
    },
    responseType: 'blob'
  })
}
// 线下活动参与
export function exportFieldCanYU (id) {
  return axiosPhp({
    method: 'get',
    url: 'wechat/activityStatics/exportCanyuList/' + id,
    // params: {
    //   search: search
    // },
    responseType: 'blob'
  })
}
// 线下关注导出
export function exportFieldGuanzhu (id) {
  return axiosPhp({
    method: 'get',
    url: 'wechat/activityStatics/exportCanyuList/' + id,
    // params: {
    //   search: search
    // },
    responseType: 'blob'
  })
}
// 线下活动场次统计导出
export function exportActivityCountList (id, search) {
  return axiosPhp({
    method: 'get',
    url: 'wechat/ActivityStatics/exportApplyStatistics/' + id,
    params: {
      id: id,
      search: search
    },
    responseType: 'blob'
  })
}
// 自动化流程保存编辑
export function editFlowChart (name, query_id, type, status, condition, id) {
  let url = 'customer/automation/' + id
  return axiosPhp.put(url, {
    name: name,
    query_id: query_id,
    type: type,
    status: status,
    condition: condition
  })
}
// 自动流程更改状态（启动或停止）
export function changeFlowChartStatus (id, status) {
  let url = 'customer/automation/updateStatus'
  return axiosPhp.post(url, {
    id: id,
    status: status
  })
}
// 微信管理 -- 公众号管理
export function publicNumber () {
  let url = 'admin/wechat/indexApi'
  return axiosPhp.get(url)
}
// 云众 -- 小程序管理
export function appletList () {
  let url = 'yunzhong/wechat_applet/indexApi'
  return axiosPhp.get(url)
}
// 云众 -- 小程序管理
export function appletTemplateList () {
  let url = 'yunzhong/wechat_applet/getTemplateList'
  return axiosPhp.get(url)
}
// 云众 -- 提交代码
export function appletCodeCommit (id, template_id, version) {
  let url = 'yunzhong/wechat_applet/codeCommit/' + id
  return axiosPhp.post(url, {
    'template_id': template_id,
    'version': version
  })
}

// 云众 -- 小程序操作
export function appletAction (id, action) {
  let url = 'yunzhong/wechat_applet/' + action + '/' + id
  return axiosPhp.post(url, {})
}
// 云众 -- 提交审核
export function appletSubmitAudit (id) {
  let url = 'yunzhong/wechat_applet/submitAudit/' + id
  return axiosPhp.post(url, {})
}
// 云众 -- 查询审核结果
export function appletAuditStatus (id) {
  let url = 'yunzhong/wechat_applet/getAuditStatus/' + id
  return axiosPhp.post(url, {})
}
// 云众 -- 发布
export function appletRelease (id) {
  let url = 'yunzhong/wechat_applet/release/' + id
  return axiosPhp.post(url, {})
}
// 公众号管理 --启用
export function changeWechatApi (data) {
  let url = 'admin/wechat/changeWechatApi'
  return axiosPhp.post(url, data)
}
// 设置默认公众号
export function setDefaultPublicNum (id) {
  let url = 'admin/wechat/setDefault/' + id
  return axiosPhp.get(url)
}
// 微信管理 -- 关键词回复
export function keywordApi (data) {
  let url = 'wechat/event_docking/keywordApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 微信管理-- 公众号回复时，微营销列表
export function ActivityList (data) {
  let url = 'wechat/marketing'
  return axiosPhp.get(url, {
    params: data
  })
}
// 微信管理-- 公众号回复时，微页面列表
export function WePagesList (data) {
  let url = 'customer/scene'
  return axiosPhp.get(url, {
    params: data
  })
}
// 关键词回复---删除
export function delKeywordApi (data) {
  let url = 'wechat/event_docking/delKeywordApi/id/'
  return axiosPhp.get(url, {
    params: data
  })
}
// 关键词回复---添加，编辑
export function editKeywordApi (data, status) {
  let url = 'wechat/event_docking/editKeywordApi'
  if (status === 2) {
    // 添加
    return axiosPhp.post(url, data)
  } else if (status === 1) {
    // 编辑
    return axiosPhp.put(url, data)
  }
}
// 关键词回复---详情
export function getKeywordDetail (data) {
  let url = 'wechat/event_docking/getKeywordDetailApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 关注回复，默认回复--详情
export function getReplyDetail (data) {
  let url = 'wechat/event_docking/replyApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 关注回复，默认回复--保存
export function getReplyDel (data) {
  let url = 'wechat/event_docking/replyApi'
  return axiosPhp.post(url, data)
}
// 关注回复，默认回复--删除
export function delReplyApi (data) {
  let url = 'wechat/event_docking/delReplyApi'
  return axiosPhp.delete(url, {
    params: data
  })
}
// 微营销列表
export function marketingListApi (data) {
  let url = 'wechat/event_docking/marketingListApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 微页面列表
export function microListApi (data) {
  let url = 'wechat/event_docking/microListApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 自定义菜单--列表
export function menuIndexApi (data) {
  let url = 'wechat/event_docking/menuIndexApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 自定义菜单--启用菜单
export function postMenu () {
  let url = 'wechat/event_docking/postMenu'
  return axiosPhp.get(url)
}
// 自定义菜单--删除
export function delMenuApi (data) {
  let url = 'wechat/event_docking/delMenuApi/id'
  return axiosPhp.get(url, {
    params: data
  })
}
// 自定义菜单--上级分类，按钮类型
export function MenuList () {
  let url = 'wechat/event_docking/editMenuApi'
  return axiosPhp.get(url)
}
// 自定义菜单--添加
export function editMenuApi (data, status) {
  let url = 'wechat/event_docking/editMenuApi'
  if (status === 2) {
    // 添加
    return axiosPhp.post(url, data)
  } else if (status === 1) {
    // 编辑
    return axiosPhp.put(url, data)
  }
}
// 自定义菜单--详情
export function editMenuDetail (data) {
  let url = 'wechat/event_docking/editMenuApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 模板消息--列表
export function messageList (data) {
  let url = 'wechat/tem_message/listApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 模板列表--列表
export function templatesApi (data) {
  let url = 'wechat/tem_message/templatesApi'
  return axiosPhp.get(url, {
    params: data
  })
}
// 模板消息--添加模板选择
export function messageAdd (id) {
  let url = 'wechat/tem_message/' + id
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// 模板消息--客户群组
export function customerGroupApi () {
  let url = 'wechat/tem_message/customerGroupApi'
  return axiosPhp.get(url)
}
// 模板消息--群发消息
export function messageSend (data) {
  let url = 'wechat/tem_message/send'
  return axiosPhp.post(url, data)
}
// 模板消息--删除
export function messageDelete (data) {
  let url = 'wechat/tem_message/delete/' + data.id
  return axiosPhp.delete(url, {
    params: data
  })
}
// 模板消息--同步模板接口
export function messageUpdate (data) {
  let url = 'wechat/tem_message/update'
  return axiosPhp.get(url, {
    params: data
  })
}
// 模板消息--复制
export function messageCopy (data) {
  let url = 'wechat/tem_message/copy'
  return axiosPhp.get(url, {
    params: data
  })
}
// 模板消息--添加
export function messageAddTrue (data) {
  let url = 'wechat/tem_message'
  return axiosPhp.post(url, data)
}
// 模板消息--详情
export function messageDetail (data) {
  let url = 'wechat/tem_message/edit/' + data.id
  return axiosPhp.get(url, {
    params: data
  })
}
// 模板消息--编辑
export function messageDeit (data) {
  let url = 'wechat/tem_message/edit'
  return axiosPhp.put(url, data)
}
// 模板消息--群发记录-下载明细
export function download (data) {
  let url = 'wechat/tem_message/download'
  return axiosPhp.get(url, {
    params: data
  })
}
// 微信支付--列表
export function payList (data) {
  let url = 'wechat/wechat_paym/index'
  return axiosPhp.get(url, {
    params: data
  })
}
// 微信支付--启用接口
export function changeWechatpay (data) {
  let url = 'wechat/wechat_paym/changeWechatpay'
  return axiosPhp.put(url, data)
}
// 微信支付--删除
export function delwechatpay (data) {
  let url = 'wechat/wechat_paym/delwechatpay'
  return axiosPhp.delete(url, {
    params: data
  })
}
// 微信支付--公众号列表
export function getWechatList () {
  let url = 'wechat/wechat_paym/getWechatList'
  return axiosPhp.get(url)
}
// 微信支付--添加,编辑
export function editPay (data, status) {
  let url = 'wechat/wechat_paym/edit'
  if (status === 2) {
    // 添加
    return axiosPhp.post(url, data)
  } else if (status === 1) {
    // 编辑
    return axiosPhp.put(url, data)
  }
}
// 微信支付--详情
export function DetailPay (data) {
  let url = 'wechat/wechat_paym/edit'
  return axiosPhp.get(url, {
    params: data
  })
}
// 广告列表
export function getAdvertiseList (page, search) {
  let url = 'admin/advert'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 广告详情
export function getAdvertiseDetails (id) {
  let url = 'admin/advert/' + id
  return axiosPhp.get(url)
}
// 广告添加
export function addAdvertise (params) {
  let url = 'admin/advert'
  return axiosPhp.post(url, params)
}
// 广告修改
export function modifyAdvertise (id, params) {
  let url = 'admin/advert/' + id
  return axiosPhp.put(url, params)
}
// 删除广告
export function deleteAdvertise (id) {
  let url = 'admin/advert/' + id
  return axiosPhp.delete(url)
}
// 广告状态修改
export function changeAdevertiseStatus (id, status) {
  let url = 'admin/advert/status'
  return axiosPhp.post(url, {
    id: id,
    status: status
  })
}
// 签到有礼设置列表
export function getSignInList () {
  let url = 'admin/Signin/index'
  return axiosPhp.get(url)
}
// 添加签到有礼设置列表
export function addSignInSettingList (params) {
  let url = 'admin/Signin/edit'
  return axiosPhp.post(url, params)
}
// 签到有礼记录列表
export function getSignInLogList (page, limit) {
  let url = 'admin/Signin/getRecordList'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page
    }
  })
}
// 权益订单 发货同步
export function sendSyncMemberData () {
  let url = '/admin/grade_order/importOrderList'
  return axiosPhp.post(url)
}
// 权益订单 订单同步
export function memberOrderSyncData () {
  let url = '/admin/grade_order/checkOrderList'
  return axiosPhp.get(url)
}
// 注册 订单发货同步
export function sendSyncData () {
  let url = '/admin/Zhuce/importOrderList'
  return axiosPhp.post(url)
}
// 注册 订单同步
export function orderSyncData () {
  let url = '/admin/Zhuce/checkOrderList'
  return axiosPhp.get(url)
}
// 签到 发货同步
export function signInSendSyncData () {
  let url = '/admin/Signin/importOrderList'
  return axiosPhp.post(url)
}
// 签到 订单同步
export function SignInOrderSyncData () {
  let url = '/admin/Signin/checkOrderList'
  return axiosPhp.get(url)
}
// 获取注册订单列表
export function getRegisterOrderList (page, search) {
  let url = 'admin/zhuce/getOrderList'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 获取签到订单列表
export function getSignInOrderList (page, search) {
  let url = 'admin/Signin/getOrderList'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 注册有礼列表
export function getRegisterList (page, search) {
  let url = 'admin/zhuce/index'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 添加注册有礼活动
export function addRegister (params) {
  let url = 'admin/zhuce/edit'
  return axiosPhp.post(url, params)
}
// 注册有礼详情
export function getRegisterDetails (id) {
  let url = 'admin/zhuce/edit'
  return axiosPhp.get(url, {
    params: {
      id: id
    }
  })
}
// 编辑注册有礼活动
export function editRegister (id, params) {
  let url = 'admin/zhuce/edit'
  return axiosPhp.put(url, params)
}
// 删除注册有礼
export function deleteRegister (id) {
  let url = 'admin/zhuce/del'
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 公告列表
export function getNoticeList (page, search) {
  let url = 'admin/notice'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 公告状态更改
export function changeNoticeStatus (id, status) {
  let url = 'admin/notice/status'
  return axiosPhp.post(url, {
    id: id,
    status: status
  })
}
// 公告详情
export function getNoticeDetails (id) {
  let url = 'admin/notice/' + id
  return axiosPhp.get(url)
}
// 公告添加 添加公告
export function addNotice (params) {
  let url = 'admin/notice'
  return axiosPhp.post(url, params)
}
// 公告修改
export function modifyNotice (id, params) {
  let url = 'admin/notice/' + id
  return axiosPhp.put(url, params)
}
// 删除公告
export function deleteNotice (id) {
  let url = 'admin/notice/' + id
  return axiosPhp.delete(url)
}
// 积分商品列表
export function getProductList (page, search) {
  let url = 'admin/product'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 积分商品状态更改
export function changeProductStatus (id, status) {
  let url = 'admin/product/status'
  return axiosPhp.post(url, {
    id: id,
    status: status
  })
}
// 商品添加
export function addProduct (params) {
  let url = 'admin/product'
  return axiosPhp.post(url, params)
}
// 商品修改
export function modifyProduct (id, params) {
  let url = 'admin/product/' + id
  return axiosPhp.put(url, params)
}
// 商品详情
export function getProductDetails (id) {
  let url = 'admin/product/' + id
  return axiosPhp.get(url)
}
// 会员等级列表
export function getMemberLevelList (page, search) {
  let url = 'admin/grade'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10,
      search: search
    }
  })
}
// 等级添加会员等级
export function addMemberLevel (params) {
  let url = 'admin/grade'
  return axiosPhp.post(url, params)
}
// 等级修改
export function modifyMemberLevel (id, params) {
  let url = 'admin/grade/' + id
  return axiosPhp.put(url, params)
}
// 等级删除
export function deleteMemberLevel (id) {
  let url = 'admin/grade/' + id
  return axiosPhp.delete(url)
}
// 会员权益列表
export function getMemberIntereseList (page, search) {
  let url = 'admin/interests'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10,
      search: search
    }
  })
}
// 会员权益状态更改
export function changeMemberInterestStatus (id, status) {
  let url = 'admin/interests/status'
  return axiosPhp.post(url, {
    id: id,
    in_status: status
  })
}
// 会员权益添加
export function addMemberInterest (params) {
  let url = 'admin/interests'
  return axiosPhp.post(url, params)
}
// 删除会员权益
export function deleteMemberInterest (id) {
  let url = 'admin/interests/' + id
  return axiosPhp.delete(url)
}
// 会员权益详情
export function getMemberInterestDetails (id) {
  let url = 'admin/interests/' + id
  return axiosPhp.get(url)
}
// admin/member/interests/:id
export function modifyMemberInterestDetails (id, params) {
  let url = 'admin/interests/' + id
  return axiosPhp.put(url, params)
}
// 会员等级详情
export function getMemberLevelDetails (id) {
  let url = 'admin/grade/' + id
  return axiosPhp.get(url)
}
// 积分商品订单列表
export function getProductOrderList (page, search) {
  let url = 'admin/order'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 积分商品订单同步
export function getIntegralSync () {
  let url = 'admin/order/sync'
  return axiosPhp.get(url)
}
// 积分商品订单发货同步
export function getDeliverSync () {
  let url = 'admin/order/deliverSync'
  return axiosPhp.get(url)
}
// 积分商品订单发货
export function changeOrderStatus (id, status) {
  let url = 'admin/order/changeStatus'
  return axiosPhp.post(url, {
    id: id,
    status: status
  })
}
// 积分设置配置列表信息
export function getIntegralSettingInfo () {
  let url = 'admin/integralSetting'
  return axiosPhp.get(url, {
    params: null
  })
}
//  更新配置项信息
export function changeIntegralSetting (params) {
  let url = 'admin/integralSetting'
  return axiosPhp.post(url, params)
}
// 添加角色
export function addRole (title, remark) {
  // let url = 'customer/group'
  let url = 'v2/shop-admin-group'
  return axiosPhp.post(url, {
    title: title,
    remark: remark
  })
}
// 角色列表
export function getRoleList (page, limit, status) {
  // let url = 'customer/group'
  // return axiosPhp.get(url, {
  //   params: {
  //     limit: limit,
  //     page: page,
  //     status: status
  //   }
  // })
  let url = 'v2/shop-admin-group/page'
  return axiosPhp.get(url,{
    params:{
      pageSize:limit,
      pageNum:page
    }
  })
}
// 角色编辑
export function editRole (title, remark, rules, id) {
  // let url = 'customer/group/' + id
  let url = 'v2/shop-admin-group/' + id
  return axiosPhp.put(url, {
    title: title,
    remark: remark,
    // rules: rules
  })
}
// 角色删除
export function deleteRole (id) {
  let url = 'v2/shop-admin-group/' + id
  return axiosPhp.delete(url)
}
// 启用禁用角色
export function useOrBanRole (ids, status) {
  let url = 'v2/shop-admin-group/' + ids + '/' + status
  return axiosPhp.put(url)
}
// 添加权限
export function addWithIn (title, name, level, pid) {
  let url = 'customer/rule'
  return axiosPhp.post(url, {
    title: title,
    name: name,
    level: level,
    pid: pid
  })
}
// 权限列表
export function getWithInList (type) {
  let url = 'customer/rule'
  return axiosPhp.get(url, {
    params: {
      type: type
    }
  })
}
// 权限详情
export function getWithInDetail (id) {
  let url = 'customer/rule/' + id
  return axiosPhp.get(url)
}
// 权限编辑
export function editRule (title, name, id) {
  let url = 'customer/rule/' + id
  return axiosPhp.put(url, {
    title: title,
    name: name
  })
}
// 启用禁用多个权限
export function useBanRules (ids, status) {
  let url = 'customer/rule/enable'
  return axiosPhp.post(url, {
    ids: ids,
    status: status
  })
}
// 权限多选删除
export function deleteRules (ids) {
  let url = 'customer/rule/deletes'
  return axiosPhp.post(url, {
    ids: ids
  })
}
// 单个权限删除
export function deleteRule (id) {
  let url = 'customer/rule/' + id
  return axiosPhp.delete(url)
}
// 角色详情
export function getRoleDetail (id) {
  let url = 'customer/group/' + id
  return axiosPhp.get(url)
}
// 获取部门
export function getDepartment (name) {
  let url = 'v2/department/list'
  return axiosPhp.get(url,{
    params:{
      name:name
    }
  })
}
//区域列表
export function getAreaList(name){
  let url = 'v2/department/getArea'
  return axiosPhp.get(url,{
    params:{
      name:name
    }
  })
}
//区域详情
export function getAreaDetail(id){
  let url = 'v2/department/details'
  return axiosPhp.get(url,{
    params:{
      id:id
    }
  })
}
// 添加部门
export function addDepartment (data) {
  let url = 'v2/department/addDepartment'
  return axiosPhp.post(url,data)
}
// 权限编辑
export function editDepartment (data) {
  let url = 'v2/department/update'
  return axiosPhp.post(url,data)
}
// 启用禁用部门
export function useBanDepartment (ids, status) {
  let url = 'v2/department/changeStatus'
  return axiosPhp.put(url, {
    id: ids,
    status: status
  })
}
// 单个部门删除
export function deleteDepartment (id) {
  let url = 'v2/department/' + id
  return axiosPhp.delete(url)
}
//部门上移
export function moveUp (id) {
  let url = 'v2/department/moveUp'
  return axiosPhp.get(url,{
    params:{
      id:id
    }
  })
}
//部门下移
export function moveDown (id) {
  let url = 'v2/department/moveDown'
  return axiosPhp.get(url,{
    params:{
      id:id
    }
  })
}
//部门升序
export function rise (id) {
  let url = 'v2/department/rise'
  return axiosPhp.get(url,{
    params:{
      id:id
    }
  })
}
//部门降序
export function fall (id) {
  let url = 'v2/department/fall'
  return axiosPhp.get(url,{
    params:{
      id:id
    }
  })
}
// 获取成员列表
export function getMember (page, limit, search) {
  let url = 'customer/user'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: limit,
      search: search
    }
  })
}
// 添加成员
export function addMember (username, realname, mobile, structure_id, group_id, password, password_confirm, remark, wine_org) {
  let url = 'customer/user'
  return axiosPhp.post(url, {
    username: username,
    realname: realname,
    mobile: mobile,
    structure_id: structure_id,
    group_id: group_id,
    password: password,
    password_confirm: password_confirm,
    remark: remark,
    wine_org: wine_org
  })
}
// 启用禁用成员
export function useBanMember (ids, status) {
  let url = 'customer/user/enable'
  return axiosPhp.post(url, {
    ids: ids,
    status: status
  })
}
// 单个成员删除
export function deleteMember (id) {
  let url = 'customer/user/' + id
  return axiosPhp.delete(url)
}
// 获取成员详情
export function getMemberDetail (id) {
  let url = 'customer/user/' + id
  return axiosPhp.get(url)
}
// 成员编辑
export function editMember (username, realname, mobile, structure_id, group_id, password, password_confirm, remark, id, wine_org) {
  let url = 'customer/user/' + id
  return axiosPhp.put(url, {
    username: username,
    realname: realname,
    mobile: mobile,
    structure_id: structure_id,
    group_id: group_id,
    password: password,
    password_confirm: password_confirm,
    remark: remark,
    wine_org: wine_org
  })
}
// 修改登录密码头像
export function editPwdAndHeadImg (type, avatar, old_pwd, new_pwd) {
  let url = 'customer/base/setInfo'
  return axiosPhp.post(url, {
    type: type,
    avatar: avatar,
    old_pwd: old_pwd,
    new_pwd: new_pwd
  })
}
// 获取客户订单列表
export function getCustomerOrderList (customerid) {
  let url = 'order/Guanyiapi/getOrderByCustomerId'
  return axiosPhp.post(url, {
    customerid: customerid
  })
}
// 获取大转盘列表给高级查询
export function getBigWheelList (search) {
  let url = 'wechat/marketing'
  return axiosPhp.get(url, {
    params: {
      limit: 0,
      page: 1,
      search: search
    }
  })
}
// 获取微页面列表
export function getWePagesList (page, limit, search) {
  let url = 'customer/scene'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: limit,
      search: search
    }
  })
}
// 创建微页面（新）
export function addWePage (name, cover_img, public_id, wechat_only, is_share, authorization, is_once, source_id, source_content, is_send_sms, publish_status, identity, redirect_url, return_msg, tags, admin_title, submit_limit) {
  let url = 'customer/scene'
  return axiosPhp.post(url, {
    name: name,
    cover_img: cover_img,
    public_id: public_id,
    wechat_only: wechat_only,
    is_share: is_share,
    authorization: authorization,
    is_once: is_once,
    source_id: source_id,
    source_content: source_content,
    is_send_sms: is_send_sms,
    publish_status: publish_status,
    identity: identity,
    redirect_url: redirect_url,
    return_msg: return_msg,
    tags: tags,
    admin_title: admin_title,
    submit_limit: submit_limit
  })
}
// 获取客户来源列表给微页面用
export function getCustomerSourceListForWepage (page) {
  let url = 'customer/source'
  return axiosPhp.get(url, {
    params: {
      limit: '',
      page: page
    }
  })
}
// 获取微页面分组列表（新）
export function getWePageGroupList (search) {
  let url = 'customer/sceneGroup'
  return axiosPhp.get(url, {
    params: {
      search: search
    }
  })
}
// 添加微页面分组(新)
export function addWePageGroup (name) {
  let url = 'customer/sceneGroup'
  return axiosPhp.post(url, {
    name: name
  })
}
// 编辑微页面分组(新)
export function editWePageGroup (name, id) {
  let url = 'customer/sceneGroup/' + id
  return axiosPhp.put(url, {
    name: name
  })
}
// 删除微页面分组(新)
export function deleteWePageGroup (id) {
  let url = 'customer/sceneGroup/' + id
  return axiosPhp.delete(url)
}
// 移动至微页面分组(新)
export function moveToWePageGroup (group_id, ids) {
  let url = 'customer/sceneGroup/move/'
  return axiosPhp.post(url, {
    group_id: group_id,
    ids: ids
  })
}
// 删除微页面(新)
export function deleteWePage (id) {
  let url = 'customer/scene/' + id
  return axiosPhp.delete(url)
}
// 微页面复制功能(新)
export function copyWePage (id) {
  let url = 'customer/scene/copy/' + id
  return axiosPhp.post(url, {
    id: id
  })
}
// 微页面统计功能（新）
export function getWePageStatisticList (id, page, limit) {
  let url = 'customer/scene/statistic/' + id
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: limit
    }
  })
}
// 微页面统计页面下载功能（新）
export function wePageStatisticDownload (id) {
  let url = 'customer/scene/export/' + id
  return axiosPhp.get(url, {
    responseType: 'blob'
  })
}
// 微页面详情回显（新）
export function getWePageDetail (id) {
  let url = 'customer/scene/' + id
  return axiosPhp.get(url)
}
// 微页面编辑（新）
export function editWePage (id, name, cover_img, public_id, wechat_only, is_share, authorization, is_once, source_id, source_content, is_send_sms, publish_status, identity, redirect_url, return_msg, tags, admin_title, submit_limit) {
  let url = 'customer/scene/' + id
  return axiosPhp.put(url, {
    name: name,
    cover_img: cover_img,
    public_id: public_id,
    wechat_only: wechat_only,
    is_share: is_share,
    authorization: authorization,
    is_once: is_once,
    source_id: source_id,
    source_content: source_content,
    is_send_sms: is_send_sms,
    publish_status: publish_status,
    identity: identity,
    redirect_url: redirect_url,
    return_msg: return_msg,
    tags: tags,
    admin_title: admin_title,
    submit_limit: submit_limit
  })
}
// 微页面发布功能(新)
export function publishWePage (id, publish_status) {
  let url = 'customer/scene/publish/' + id
  return axiosPhp.post(url, {
    publish_status: publish_status
  })
}
// 业务员列表
export function getSalesmanList (page, search, limit = 10) {
  let url = 'wechat/salesman'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: limit,
      search: search
    }
  })
}
// 编辑业务员
export function editSalesman (form, id) {
  let url = 'wechat/salesman/' + id
  return axiosPhp.put(url, form)
}
// 删除业务员
export function deleteSalesman (id) {
  let url = 'wechat/salesman/' + id
  return axiosPhp.delete(url)
}
// 微信绑定业务员
export function getSalesmanDetails (id) {
  let url = 'wechat/salesman/' + id
  return axiosPhp.get(url)
}
// 添加微信二维码活动
export function addWeChayAcivity (data) {
  let url = 'wechat/qrcodesActivity'
  return axiosPhp.post(url, data)
}
// 微信二维码活动列表
export function getWeChatActivityList (page, public_id, search) {
  let url = 'wechat/qrcodesActivity'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      public_id: public_id,
      search: search
    }
  })
}
// 删除微信二维码活动
export function deleteWeChatActivity (id) {
  let url = 'wechat/qrcodesActivity/' + id
  return axiosPhp.delete(url)
}
// 微信二维码活动详情
export function getWeChatActivityDetails (id) {
  let url = 'wechat/qrcodesActivity/' + id
  return axiosPhp.get(url)
}
// 编辑微信二维码活动
export function editWeChatActivity (data, id) {
  let url = 'wechat/qrcodesActivity/' + id
  return axiosPhp.put(url, data)
}
// ************活动统计*************

// 数据统计列表
export function getqrcodeActivityList (page, limit, search) {
  let url = 'wechat/activityStatics'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: limit,
      search: search
    }
  })
}
// 获取部门数据列表
export function getStructureList (data) {
  let url = 'customer/structure'
  return axiosPhp.get(url, {
    params: {
      data: data
    }
  })
}
// 获取业务员数据列表
export function getSaleManList (data) {
  let url = 'customer/structure'
  return axiosPhp.get(url, {
    params: {
      data: data
    }
  })
}
// 新建二维码活动
export function addActivityQrcode (qrcode_name, salesman_id, activity_id) {
  let url = 'wechat/activityStatics'
  return axiosPhp.post(url, {
    qrcode_name: qrcode_name,
    salesman_id: salesman_id,
    activity_id: activity_id
  })
}
// 删除列表统计
export function deleteActivityList (id) {
  let url = 'wechat/activityStatics/' + id
  return axiosPhp.delete(url)
}
// 业务员二维码统计详情
export function getQrcodeDetails (id) {
  let url = 'wechat/activityStatics/' + id
  return axiosPhp.get(url)
}
// 线下活动配置设置提交
export function offlineActivitySet (title, page_name, cover_img, content, wechat_id) {
  let url = 'wechat/qrcodesActivityConfig'
  return axiosPhp.post(url, {
    title: title,
    page_name: page_name,
    cover_img: cover_img,
    content: content,
    wechat_id: wechat_id
  })
}
// 线下活动配置详情
export function getOfflineActivitySet (wechat_id) {
  let url = 'wechat/qrcodesActivityConfig/detail'
  return axiosPhp.get(url, {
    params: {
      wechat_id: wechat_id
    }
  })
}
// 公众号启用
export function startOrStopPublic (id, is_disable) {
  let url = 'admin/wechat/disable/' + id
  return axiosPhp.post(url, {
    is_disable: is_disable
  })
}
// 首页--客户来源
export function getSource (type) {
  let url = 'customer/statistic/source'
  return axiosPhp.get(url, {
    params: {
      type: type
    }
  })
}
// 获取素材列表
export function getSourceMaterialList (original_id) {
  let url = 'wechat/material/list/' + original_id
  return axiosPhp.get(url)
}
// 微信素材预览
export function wechatGroupPreview (data) {
  let url = 'wechat/material/sendOne'
  return axiosPhp.post(url, data)
}
// 获取统计信息（群发记录）
export function getWechatSendGroupRecord (original_id, page, limit) {
  let url = 'wechat/material/statistic/' + original_id
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: 10
    }
  })
}
// 微信群发消息
export function sendWechatMessage (data) {
  let url = 'wechat/material/getCondition'
  return axiosPhp.get(url, {
    params: {
      original_id: data.original_id,
      type: data.type,
      send_type: data.send_type,
      media_id: data.media_id,
      text: data.text,
      group_id: data.group_id,
      start_time: data.start_time
    }
  })
}
// 获取剩余预览次数
export function getleftPreviewCount (original_id) {
  let url = 'wechat/material/getPreviewCount'
  return axiosPhp.get(url, {
    params: {
      original_id: original_id
    }
  })
}
// 查看导出详情
export function lookExporDetail (id) {
  let url = 'customer/setup/showExportProgress/' + id
  return axiosPhp.get(url)
}
// 查看微页面标题是佛重复
export function checkWeiPageTitle (name, scene_id) {
  let url = 'customer/scene/checkTitle'
  return axiosPhp.get(url, {
    params: {
      name: name,
      scene_id: scene_id
    }
  })
}
// 活动申请统计
export function activityApplyTotal (page, limit, id, salesman, starttime, endtime) {
  let url = 'wechat/activityStatics/applyStatistics'
  return axiosPhp.get(url, {
    params: {
      page: page,
      limit: limit,
      id: id,
      salesman: salesman,
      starttime: starttime,
      endtime: endtime
    }
  })
}
// 活动类型给场次筛选用
export function getWeChatActivityListForFiled (page, search, public_id) {
  let url = 'wechat/qrcodesActivity'
  return axiosPhp.get(url, {
    params: {
      limit: '',
      page: page,
      search: search,
      public_id: public_id
    }
  })
}
// 场次统计
export function getFiledTotal (id, limit, page) {
  let url = 'wechat/ActivityStatics/subscribeList/' + id
  return axiosPhp.get(url, {
    params: {
      limit: limit,
      page: page
    }
  })
}
// 标签管理列表
export function getTagsList (name) {
  let url = 'customer/tag'
  return axiosPhp.get(url, {
    params: {
      limit: 20,
      search: {
        name: name
      }
    }
  })
}
//
export function getActivityStatics (id, modelId, page) {
  let url = 'wechat/ActivityStatics/canyuList/' + id + '?model_id=' + modelId
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page
    }
  })
}
// 线下活动数据统计的活动类型列表
export function getActivityStaticsActTypes (public_id) {
  let url = 'wechat/qrcodesActivity/qrcodesActivityReplayScene'
  return axiosPhp.get(url, {
    params: {
      public_id: public_id
    }
  })
}
// 线下活动数据统计的活动类型下的具体列表
export function getActivityStaticsActRealList (activity_id, page, limit, search) {
  let url = 'wechat/activityStatics/subscribActivityList'
  return axiosPhp.get(url, {
    params: {
      activity_id: activity_id,
      page: page,
      limit: limit,
      search: search
    }
  })
}
// 线下活动数据统计的活动类型下的导出
export function activityStaticsActRealListDownload (activity_id, page, limit, search) {
  let url = 'wechat/activityStatics/exportSubcribActivityList'
  return axiosPhp.get(url, {
    params: {
      activity_id: activity_id,
      page: page,
      limit: limit,
      search: search
    },
    responseType: 'blob'
  })
}
// 宝箱创建活动
export function createTreasureBoxActivity (data) {
  let url = 'treasure_box/manage'
  return axiosPhp.post(url, data)
}
// 宝箱活动列表
export function getTreasureBoxList (page, search) {
  let url = 'treasure_box/manage'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 宝箱活动详情
export function getTreasureBoxDetail (id) {
  let url = 'treasure_box/manage/' + id
  return axiosPhp.get(url)
}
// 编辑宝箱
export function editTreasureBox (id, data) {
  let url = 'treasure_box/manage/' + id
  return axiosPhp.put(url, data)
}
// 宝箱活动统计
export function getTreasureBoxActivityStatics (id, page, search) {
  let url = 'treasure_box/manage/statistic/' + id
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 禁用宝箱
export function stopTreasureBoxActivity (id) {
  let url = 'treasure_box/manage/enable'
  return axiosPhp.post(url, {
    ids: id
  })
}
// 宝箱活动导出
export function exportTreasureBoxActivity (id, search) {
  let url = 'treasure_box/manage/export/' + id
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}
// ====================== 猜灯谜活动 ====================== //
// 猜灯谜活动列表
export function getGuessRiddlesList (page, search) {
  let url = 'guess_riddles/manage'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 猜灯谜创建活动
export function createGuessRiddlesActivity (data) {
  let url = 'guess_riddles/manage'
  return axiosPhp.post(url, data)
}
// 猜灯谜活动详情
export function getGuessRiddlesDetail (id) {
  let url = 'guess_riddles/manage/' + id
  return axiosPhp.get(url)
}
// 编辑猜灯谜
export function editGuessRiddles (id, data) {
  let url = 'guess_riddles/manage/' + id
  return axiosPhp.put(url, data)
}
// 猜灯谜活动统计
export function getGuessRiddlesActivityStatics (id, page, search) {
  let url = 'guess_riddles/manage/statistic/' + id
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 猜灯谜活动导出
export function exportGuessRiddlesActivity (id, search) {
  let url = 'guess_riddles/manage/export/' + id
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}
// 题库列表
export function getGuessRiddlesTopicList (page, search) {
  let url = 'guess_riddles/topic'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 编辑题面
export function editGuessRiddlesTopic (id, data) {
  let url = 'guess_riddles/topic/' + id
  return axiosPhp.put(url, data)
}
// 添加题面
export function createGuessRiddlesTopic (data) {
  let url = 'guess_riddles/topic'
  return axiosPhp.post(url, data)
}
// 题目详情
export function getGuessRiddlesTopicDetail (id) {
  let url = 'guess_riddles/topic/' + id
  return axiosPhp.get(url)
}
// 龙抬头创建活动
export function createDragonActivity (data) {
  let url = 'dragon/manage'
  return axiosPhp.post(url, data)
}
// 龙抬头活动列表
export function getDragonList (page, search) {
  let url = 'dragon/manage'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 龙抬头活动详情
export function getDragonDetail (id) {
  let url = 'dragon/manage/' + id
  return axiosPhp.get(url)
}
// 编辑龙抬头
export function editDragon (id, data) {
  let url = 'dragon/manage/' + id
  return axiosPhp.put(url, data)
}
// 龙抬头活动统计
export function getDragonActivityStatics (id, page, search) {
  let url = 'dragon/manage/statistic/' + id
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 禁用龙抬头
export function stopDragonActivity (id) {
  let url = 'dragon/manage/enable'
  return axiosPhp.post(url, {
    ids: id
  })
}
// 龙抬头活动导出
export function exportDragonActivity (id, search) {
  let url = 'dragon/manage/export/' + id
  return axiosPhp({
    method: 'get',
    url: url,
    params: {
      search: search
    },
    responseType: 'blob'
  })
}

//跳转云众
export function toYunzhong (authKey, sessionId, userInfo) {
  let url = YZ_HOST_API + 'admin/base/login'
  return axiosPhp.post(url, {
    authKey: authKey,
    sessionId: sessionId,
    userInfo: userInfo
  })
}

//跳转云团
export function toYuntuan (authKey, sessionId, userInfo) {
  let url = YT_HOST_API + 'admin/index/login'
  window.open(url + '?authKey=' + authKey + '&sessionId=' + sessionId + '&userInfo=' + userInfo)
}

// 开放平台接口
// 获取开放平台配置
export function openPlatform () {
  let url = 'customer/openPlatform'
  return axiosPhp.get(url)
}
// 保存开放平台配置
export function openPlatformSave (data) {
  let url = 'customer/openPlatform'
  return axiosPhp.post(url, data)
}
// 获取权限
export function fetchMenuList (data) {
  const url = 'v2/zy/company/perms'
  return axiosPhp.get(url, {
    params: data
  })
}
//获取分析指标二级下拉 获取分析zhi
export function fetchAnalyseIdentity (eventIds) {
  const url = 'v2/anlys/behavior/qutaIdentitys'
  return axiosPhp.get(url, {
    params: {
      eventIds
    }
  })
}

// 获取分析维度  根据事件获取事件属性的下拉
export function analyseDimensionEventIdentity (eventIds) {
  const url = 'v2/anlys/behavior/dimessionIdentitys'
  return axiosPhp.get(url, {
    params: {
      eventIds
    }
  })
}


